import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormGroup, ControlLabel, FormControl, Button } from "react-bootstrap";

// const required = value => (value || typeof value === 'number' ? undefined : 'Required')
// const maxLength = max => value =>
//   value && value.length > max ? `Must be ${max} characters or less` : undefined
// const maxLength15 = maxLength(15)
// export const minLength = min => value =>
//   value && value.length < min ? `Must be ${min} characters or more` : undefined
// export const minLength2 = minLength(2)
// const number = value =>
//   value && isNaN(Number(value)) ? 'Must be a number' : undefined
const invalidEmail = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);

// const alphaNumeric = value =>
//   value && /[^a-zA-Z0-9 ]/i.test(value)
//     ? 'Only alphanumeric characters'
//     : undefined

const invalidMobileNumber = value =>
  value && !/\d{10,11}$/i.test(value);

const validateContact = contact => {
  const errors = [];
  if (!contact.name) {
    errors.push("Name is required");
    return errors;
  }
  if (!contact.email && !contact.mobile) {
    errors.push("A Contact requires an email and/or a mobile");
    return errors;
  }
  if (invalidEmail(contact.email)) {
    errors.push("Invalid Email address");
  }
  if (invalidMobileNumber(contact.mobile)) {
    errors.push("Invalid Mobile number. Needs to be numbers only, between 10-11 characters long");
  }
  return errors;
};

function FieldGroup({ id, label, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
    </FormGroup>
  );
}
FieldGroup.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

// <Form model={} onSubmit={}
class ContactForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      contact: {
        name: "",
        email: "",
        mobile: "",
        emailNotification: ["job.selected"],
        mobileNotification: ["job.selected"]
      },
      errors: [],
      submitting: false
    };
  }

  handleChange(event) {
    const target = event.target;
    this.setState({
      contact: { ...this.state.contact, [target.name]: target.value }
    });
  }

  handleSubmit() {
    this.setState({ submitting: true });
    const { contact } = this.state;
    const errors = validateContact(contact);
    if (errors.length) {
      this.setState({ errors, submitting: false });
    } else {
      this.props.onSubmit(contact).then(() => {
        this.setState({
          errors: [],
          contact: {
            name: "",
            email: "",
            mobile: "",
            emailNotification: ["job.selected"],
            mobileNotification: ["job.selected"]
          },
          submitting: false
        });
      });
    }
  }

  render() {
    const { contact, errors, submitting } = this.state;

    return (
      <div>
        <h4>Create Contact</h4>
        {errors.length ? (
          <ul>{errors.map(error => <li key={error}>{error}</li>)}</ul>
        ) : (
          ""
        )}
        <FieldGroup
          id="contact-name-group"
          name="name"
          type="text"
          label="Name"
          placeholder="Contact name"
          value={contact.name}
          onChange={this.handleChange}
        />
        <FieldGroup
          id="contact-email-group"
          name="email"
          type="email"
          label="Email"
          placeholder="Email"
          value={contact.email}
          onChange={this.handleChange}
        />
        <FieldGroup
          id="contact-mobile-group"
          name="mobile"
          type="text"
          label="Mobile"
          placeholder="Mobile"
          value={contact.mobile}
          onChange={this.handleChange}
        />
        <Button
          bsStyle="primary"
          disabled={submitting}
          onClick={this.handleSubmit}
        >
          Create Contact
        </Button>
      </div>
    );
  }
}
ContactForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/forms/ContactForm.js